<template>
  <div>
    <v-row justify="center">
      <v-col cols="4">
        <h2 style="line-height: 1.1">Qual dashboard você quer na página inicial?</h2>
        <v-select
          v-model="selectedDashboard"
          :items="dashboards"
          item-text="descricao"
          return-object
          outlined
          class="mt-8"
          @change="onDashboardChange"
        />
        <v-btn color="accent" :disabled="selectedIndex === userDashboadSelectedIndex" @click="salvarDashboardUsuario">
          Salvar
        </v-btn>
      </v-col>
      <v-col cols="6" class="ml-6 position-relative">
        <img src="@/assets/mockup-tela-desktop.png" alt="" class="mockup-img" />

        <v-carousel
          ref="carousel"
          v-model="selectedIndex"
          :height="carouselHeight"
          :show-arrows="false"
          hide-delimiters
          class="carousel-overlay pt-5 pt-md-7 px-5 px-md-7"
        >
          <v-carousel-item v-for="(dashboard, i) in dashboards" :key="i" :src="dashboard.src" />
        </v-carousel>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import DashboardService from '@/services/DashboardService';
  import UsuariosService from '@/services/UsuariosService';

  export default {
    name: 'DashboardUsuario',
    props: {
      userInfo: {
        type: Object,
        default: () => {}
      },
      height: {
        type: Number,
        default: 500
      }
    },
    data: () => ({
      items: [],
      selectedIndex: 0,
      selectedDashboard: null,
      carouselHeight: 0
    }),
    computed: {
      dashboards() {
        return this.items.map((item, i) => ({
          ...item,
          index: i,
          src: `/dashboards/${item.codigo}.png`,
          descricao: item.titulo + (item.descricao ? ` :: ${item.descricao}` : '')
        }));
      },
      dashboardSelecionado() {
        return this.selectedDashboard || this.dashboards[this.selectedIndex];
      },
      descricaoDashboardSelecionado() {
        let descricao = '';
        if (this.dashboardSelecionado && this.dashboardSelecionado.titulo) descricao += this.dashboardSelecionado.titulo;
        if (this.dashboardSelecionado && this.dashboardSelecionado.descricao)
          descricao += ` :: ${this.dashboardSelecionado.descricao}`;
        return descricao;
      },
      userDashboadSelectedIndex() {
        return this.items.findIndex((item) => this.userInfo && this.userInfo.dashboard && this.userInfo.dashboard.id === item.id);
      }
    },
    mounted() {
      this.getDashboards();
      this.updateCarouselSize();
      window.addEventListener('resize', this.updateCarouselSize);
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.updateCarouselSize);
    },
    methods: {
      getDashboards() {
        DashboardService.getDashboards().then(({ data }) => {
          this.items = data || [];

          // index inicial
          const idx = this.userDashboadSelectedIndex;
          this.selectedIndex = idx !== -1 ? idx : 0;

          // opção selecionada no combobox
          this.selectedDashboard = this.dashboards[this.selectedIndex];
        });
      },
      salvarDashboardUsuario() {
        if (!this.dashboardSelecionado || !this.dashboardSelecionado.id) return;

        UsuariosService.salvarDashboard(this.dashboardSelecionado.id)
          .then(() => {
            this.$toast.success('Dashboard preferido salvo com sucesso.', '', {
              position: 'topRight'
            });
            this.$emit('dashboard:novo-preferido-configurado', this.dashboardSelecionado);
          })
          .catch(() => {
            this.$toast.error('Erro ao salvar a nova configuração do dashboard.', '', { position: 'topRight' });
          });
      },
      onDashboardChange(selectedItem) {
        if (!selectedItem) return;
        this.selectedIndex =
          typeof selectedItem.index === 'number'
            ? selectedItem.index
            : this.dashboards.findIndex((d) => d.id === selectedItem.id);
      },
      updateCarouselSize() {
        const el = this.$el.querySelector('.mockup-img');
        if (!el) return;

        const width = el.offsetWidth;
        if (width < 600) this.carouselHeight = width * (9.5 / 16);
        else this.carouselHeight = width * (9.2 / 16);
      }
    }
  };
</script>

<style>
  .position-relative {
    position: relative;
  }

  .mockup-img {
    width: 100%;
    display: block;
    position: relative;
    z-index: 2; /* imagem por cima */
  }

  .carousel-overlay {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1; /* carousel atrás */
  }
</style>
